import {
    Tooltip,
    Column,
    Checkbox,
    DataTable,
    PrimeIcons,
    Skeleton,
    Button,
    Toast,
    Dropdown,
    Messages,
} from 'primereact';
import {OtrosPermisosButton} from "./OtrosPermisosButton";

const permisosBase = ["Listar", "Crear", "Editar", "Clonar", "Cancelar"];

export const InnerTable = (
  data,
  checkList,
  setCheckList,
  todosCheckList,
  setTodosCheckList,
  menusCheckList,
  setMenusCheckList
) => {
  const handleCheck = (funcionData) => {
    if (checkList.some((f) => f === funcionData.IdSec)) {
      setCheckList((prev) => prev.filter((f) => f !== funcionData.IdSec));
    } else {
      setCheckList((prev) => [...prev, funcionData.IdSec]);
    }
  };

  return (
    <div>
      <DataTable
        className="datatable-internal"
        value={data?.entidadesHijo}
        style={{ zIndex: 1 }}
      >
        <Column body={(data) => <span>{data.Nombre}</span>} />
        <Column
          header="Todos"
          body={(dataFuncion) => {
            let funciones = dataFuncion.Funciones;
            const permisosMenu = dataFuncion?.Menus?.map((m) => m.IdSec) ?? [];
            return (
              <div>
                {funciones.length > 0 && (
                  <Checkbox
                    style={{ marginLeft: "10px" }}
                    onChange={(e) => {
                      if (todosCheckList.some((t) => t === dataFuncion.Id)) {
                        setCheckList((prev) => {
                          return prev.filter((v) =>
                            funciones.some((f) => f.IdSec === v) ? false : true
                          );
                        });
                        setTodosCheckList((prevValue) => [
                          ...prevValue.filter((t) => t !== dataFuncion.Id),
                        ]);
                        setMenusCheckList((prev) =>
                          prev.filter((m) => !permisosMenu.includes(m))
                        );
                      } else {
                        setCheckList((prev) => [
                          ...prev,
                          ...funciones.map((f) => f.IdSec),
                        ]);
                        setMenusCheckList((prevValue) => {
                          const uniqueElements = new Set([
                            ...prevValue,
                            ...permisosMenu,
                          ]);
                          return Array.from(uniqueElements);
                        });
                        setTodosCheckList((prevValue) => [
                          ...prevValue,
                          dataFuncion.Id,
                        ]);
                      }
                    }}
                    checked={
                      todosCheckList.some((t) => t === dataFuncion.Id) ?? false
                    }
                  />
                )}
              </div>
            );
          }}
        ></Column>
        <Column
          header="Listar"
          body={(dataFuncion) => {
            const funcionData = dataFuncion?.Funciones.find(
              (f) => f.Funcion === "Listar"
            );
            return (
              <div>
                {funcionData && (
                  <Checkbox
                    style={{ marginLeft: "10px" }}
                    checked={
                      checkList.some((t) => t === funcionData.IdSec) ?? false
                    }
                    onChange={(e) => {
                      handleCheck(funcionData);
                    }}
                  />
                )}
              </div>
            );
          }}
        ></Column>
        <Column
          header="Crear"
          body={(dataFuncion) => {
            const funcionData = dataFuncion?.Funciones.find(
              (f) => f.Funcion === "Crear"
            );
            return (
              <div>
                {funcionData && (
                  <Checkbox
                    style={{ marginLeft: "10px" }}
                    checked={
                      checkList.some((t) => t === funcionData.IdSec) ?? false
                    }
                    onChange={(e) => {
                      handleCheck(funcionData);
                    }}
                  />
                )}
              </div>
            );
          }}
        ></Column>
        <Column
          header="Editar"
          body={(dataFuncion) => {
            const funcionData = dataFuncion?.Funciones.find(
              (f) => f.Funcion === "Editar"
            );
            return (
              <div>
                {funcionData && (
                  <Checkbox
                    style={{ marginLeft: "10px" }}
                    checked={
                      checkList.some((t) => t === funcionData.IdSec) ?? false
                    }
                    onChange={(e) => {
                      handleCheck(funcionData);
                    }}
                  />
                )}
              </div>
            );
          }}
        ></Column>
        <Column
          header="Clonar"
          body={(dataFuncion) => {
            const funcionData = dataFuncion?.Funciones.find(
              (f) => f.Funcion === "Clonar"
            );
            return (
              <div>
                {funcionData && (
                  <Checkbox
                    style={{ marginLeft: "10px" }}
                    checked={
                      checkList.some((t) => t === funcionData.IdSec) ?? false
                    }
                    onChange={(e) => {
                      handleCheck(funcionData);
                    }}
                  />
                )}
              </div>
            );
          }}
        ></Column>
        <Column
          header="Cancelar"
          body={(dataFuncion) => {
            const funcionData = dataFuncion?.Funciones.find(
              (f) => f.Funcion === "Cancelar"
            );
            return (
              <div>
                {funcionData && (
                  <Checkbox
                    style={{ marginLeft: "18px" }}
                    checked={
                      checkList.some((t) => t === funcionData.IdSec) ?? false
                    }
                    onChange={(e) => {
                      handleCheck(funcionData);
                    }}
                  />
                )}
              </div>
            );
          }}
        ></Column>
        <Column
          header="Menu"
          body={(dataFuncion) => {
            const permisosMenu = dataFuncion?.Menus?.map((m) => m.IdSec) ?? [];
            return (
              <div>
                {permisosMenu.length > 0 && (
                  <Checkbox
                    style={{ marginLeft: "10px" }}
                    checked={
                      permisosMenu.every((m) => menusCheckList.includes(m)) ??
                      false
                    }
                    onChange={(e) => {
                      if (
                        permisosMenu.every((m) => menusCheckList.includes(m))
                      ) {
                        setMenusCheckList((prevValue) => [
                          ...prevValue.filter((t) => !permisosMenu.includes(t)),
                        ]);
                      } else {
                        setMenusCheckList((prevValue) => {
                          const uniqueElements = new Set([
                            ...prevValue,
                            ...permisosMenu,
                          ]);
                          return Array.from(uniqueElements);
                        });
                      }
                    }}
                  />
                )}
              </div>
            );
          }}
        ></Column>
        <Column
          header="Otros"
          body={(dataFuncion) => {
            const funciones = dataFuncion?.Funciones.filter(
              (f) => !permisosBase.some((p) => p === f.Funcion)
            );
            return (
              <div>
                {funciones.length > 0 ? (
                  <OtrosPermisosButton
                    permisos={funciones}
                    checkList={checkList}
                    setCheckList={setCheckList}
                  />
                ) : (
                  <div></div>
                )}
              </div>
            );
          }}
        ></Column>
      </DataTable>
    </div>
  );
};
